import type { SiteConfig } from '@/types'

// Canonical address of the live site. Used for canonical links, Open Graph URLs,
// structured data, the sitemap and robots.txt. Update it when a custom domain is connected.
const SITE_URL = 'https://anushka-beauty-parlour.modulify.website'

export const siteConfig: SiteConfig = {
    name: 'Anushka Beauty Parlour',
    tagline: 'The salon for your beauty',
    description: "Women's beauty parlour in New Gupta Colony, Delhi for bridal makeup, party makeovers, nail art, skin treatments, facial cleanup and hair care. Open daily 10 AM to 8:30 PM.",
    url: SITE_URL,
    locale: 'en_IN',
    ogImage: '/images/makeup-artist.jpg',
    ogImageAlt: 'Woman applying makeup at a mirror, Anushka Beauty Parlour in New Gupta Colony, Delhi',
    keywords: [
        'Anushka Beauty Parlour',
        'beauty parlour in New Gupta Colony',
        'Bridal Makeups in New Gupta Colony',
        'HD & Airbrush Bridal Looks',
        'Designer Nail Arts & Extensions',
        'Organic Skin Treatments & Facial Cleanup',
        'Hair Care & Bridal Hair Designs',
        'Party Makeovers & Draping',
        'best beauty parlour nearby',
        'nail arts nearby',
        'hair keratin treatment',
        'nail salon near me',
        'bridal beauty makeup artist Delhi',
        'skin treatment Delhi',
        'facial parlour near me',
        'top beauty parlour in Delhi',
        'best beauty salons near me',
        'party makeup artist near me',
        "women's beauty parlour in North Delhi",
        'ladies beauty parlour near me',
        'beauty parlour in Model Town',
        'beauty parlour in GTB Nagar',
        'beauty parlour in Vijay Nagar',
        'beauty parlour in Kamla Nagar',
        'makeup artist in North Delhi',
        'saree draping near me',
        'hair smoothening and rebonding in Delhi',
        'engagement makeup artist Delhi'
    ]
}

export const contact = {
    phoneDisplay: '+91 92786 37482',
    phoneShort: '92786 37482',
    phoneHref: 'tel:+919278637482',
    phoneSchema: '+91-9278637482',
    whatsappNumber: '919278637482',
    instagramUrl: 'https://www.instagram.com/anushka_beauty_parlou?dlrf=MTRyb2Z3dmo4bzE1eA==',
    instagramProfile: 'https://www.instagram.com/anushka_beauty_parlou/',
    instagramHandle: '@anushka_beauty_parlou',
    mapsUrl: 'https://maps.app.goo.gl/9yVNxjCmQPhPZNYP8'
}

export const address = {
    shop: 'B-57',
    street: 'Street No. 16',
    landmark: 'Near Jain Dental Clinic',
    locality: 'New Gupta Colony',
    area: 'Kalyan Vihar',
    city: 'Delhi',
    region: 'Delhi',
    postalCode: '110009',
    country: 'IN',
    lineOne: 'B-57, Street No. 16, New Gupta Colony',
    lineTwo: 'Kalyan Vihar, Delhi 110009',
    full: 'B-57, Street No. 16, near Jain Dental Clinic, New Gupta Colony, Kalyan Vihar, Delhi 110009',
    mapsQuery: 'Anushka Beauty Parlour, B-57, Street Number 16, New Gupta Colony, Kalyan Vihar, Delhi 110009',
    nearestMetro: 'Model Town Metro Station (Yellow Line)'
}

export const hours = {
    days: 'Open all 7 days',
    label: '10:00 AM to 8:30 PM',
    shortLabel: '10 AM to 8:30 PM',
    opensLabel: '10:00 AM',
    closesLabel: '8:30 PM',
    opens: '10:00',
    closes: '20:30',
    openMinute: 10 * 60,
    closeMinute: 20 * 60 + 30,
    timeZone: 'Asia/Kolkata'
}

export const areasServed = [
    'New Gupta Colony',
    'Old Gupta Colony',
    'Kalyan Vihar',
    'Model Town',
    'Vijay Nagar',
    'GTB Nagar',
    'Hudson Lane',
    'Mukherjee Nagar',
    'Kingsway Camp',
    'Outram Lines',
    'Roop Nagar',
    'Kamla Nagar',
    'Shakti Nagar',
    'Malka Ganj',
    'Delhi University North Campus',
    'Rana Pratap Bagh',
    'Gujranwala Town',
    'Derawal Nagar',
    'CC Colony',
    'Kirpal Bagh',
    'Rajpura',
    'Gurmandi',
    'Sardar Nagar',
    'University Enclave',
    'Ashok Vihar',
    'Nirankari Colony',
    'Azadpur',
    'Adarsh Nagar',
    'North Delhi'
]

export const whatsappMessages = {
    general: 'Hello Anushka Beauty Parlour, I would like to book an appointment.',
    bridal: 'Hello Anushka Beauty Parlour, I would like to book bridal makeup. My wedding date is ',
    charges: 'Hello Anushka Beauty Parlour, could you please share the details and charges for '
}

export const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'Why Us', href: '/#why-us' },
    { label: 'Services', href: '/#services' },
    { label: 'Instagram', href: '/#instagram' },
    { label: 'Visit Us', href: '/#visit' },
    { label: 'FAQ', href: '/#faq' }
]
